export const NoteTemp3 = [
    {
        "sub_grp": [
            {
                "sid": "6198d4da372ac8b9c064b923",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Freehold Land - Closing Gross Carrying Amount",
                    "cy_amt": 0,
                    "py_amt": 0
                },
            },
            {
                "sid": "6198d4da372ac8b9c064b92b",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Freehold Land - Closing Accumulated Depreciation",
                    "cy_amt": 0,
                    "py_amt": 0
                },
            },
            {
                "sid": "6198d4da372ac8b9c064b934",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Freehold Buildings - Closing Gross Carrying Amount",
                    "cy_amt": 0,
                    "py_amt": 0
                },
         
            },
            {
                "sid": "6198d4da372ac8b9c064b93c",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Freehold buildings - Closing accumulated depreciation",
                    "cy_amt": 0,
                    "py_amt": 0
                },
             
            },
            {
                "sid": "6198d4da372ac8b9c064b945",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Furniture, Fittings & Equipment - Closing Gross Carrying Amount",
                    "cy_amt": 0,
                    "py_amt": 0
                },
         
            },
            {
                "sid": "6198d4da372ac8b9c064b94d",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Furniture, Fittings & Equipment - Closing Accumulated Depreciation",
                    "cy_amt": 0,
                    "py_amt": 0
                },
            },
            {
                "sid": "6198d4da372ac8b9c064b956",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Plant & Machinery - Closing Gross Carrying Amount",
                    "cy_amt": 0,
                    "py_amt": 0
                },
            
            },
            {
                "sid": "6198d4da372ac8b9c064b95e",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Plant & Machinery - Closing Accumulated Depreciation",
                    "cy_amt": 0,
                    "py_amt": 0
                },
           
            },
            {
                "sid": "6198d4da372ac8b9c064b967",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Total - Closing Gross Carrying Amount",
                    "cy_amt": 0,
                    "py_amt": 0
                },
         
            },
            {
                "sid": "6198d4da372ac8b9c064b96f",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Total - Closing Accumulated Depreciation",
                    "cy_amt": 0,
                    "py_amt": 0
                },
            },

        ],
        "notes_no": "3",
        "notes_grp": "Property, Plant & Equipment",
        "fs_grp": "Non Current Assets",
    },
    {   
        "sub_grp": [
            {
                "sid": "6198d4da372ac8b9c064b97f",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Closing Gross Carrying Amount",
                    "cy_amt": 0,
                    "py_amt": 0
                },
                
            },
            {
                "sid": "6198d4da372ac8b9c064b987",
                "fs_grp": "",
                "sub_grp": {
                    "sub_grp": "Closing Accumulated Depreciation",
                    "cy_amt": 0,
                    "py_amt": 0
                },
                
            },
        ],
        "notes_no": "3",
        "notes_grp": "Capital Work-In Progress",
        "fs_grp": "Non Current Assets",
    }
]
